export const moleculeTypes = {
  REGULAR: 'regular',
  BREAK: 'break',
  PRODUCT: 'product',
}

export const moleculeSizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
}

export const moleculeCategories = {
  ACID: 'amino-acid',
  FAT: 'fatty-acid',
  SUGAR: 'sugar',
}

export const fatChainLengths = [
  {
    chainLength: 2,
    title: 'acetaat',
    doubleBindings: 0,
  },
  {
    chainLength: 4,
    title: 'butyraat',
    doubleBindings: 0,
  },
  {
    chainLength: 6,
    title: 'hexanoaat',
    doubleBindings: 0,
  },
  {
    chainLength: 8,
    title: 'octanoaat',
    doubleBindings: 0,
  },
  {
    chainLength: 10,
    title: 'decanoaat',
    doubleBindings: 0,
  },
  {
    chainLength: 12,
    title: 'lauraat',
    doubleBindings: 0,
  },
  {
    chainLength: 14,
    title: 'myristaat',
    doubleBindings: 0,
  },
  {
    chainLength: 16,
    title: 'palmitaat',
    doubleBindings: 0,
  },
  {
    chainLength: 18,
    title: 'stearaat',
    doubleBindings: 0,
  },
  {
    chainLength: 18,
    title: 'oleaat',
    doubleBindings: 1,
  },
  {
    chainLength: 20,
    title: 'propionaat',
    doubleBindings: 0,
  },
]

export const visibleChainLengthMolecules = [
  'm13jke9l',
  '0p9dd69v',
  'j2971q94',
  '1oxv7zxd',
  '123687xm',
  'rd956yxe',
  'm430kwxr',
  'mr3nmmxz',
  'dg98ko9m',
  'r8x2md96',
  'oy3w4oxe']
